import React from 'react'
import ContentLoader from 'react-content-loader'

const CommunityCardLoader = () => {
    return (
        <div
            style={{
                backgroundColor: '#fff',
                borderRadius: '0.5rem',
                padding: '8px',
                margin: '1rem 0',
                border: '1px solid #d5d8df',
            }}
        >
            <ContentLoader
                height={100}
                width={500}
                speed={1}
                primaryColor="#dbdbdb"
                secondaryColor="#ecebeb"
            >
                {/* Icon (left) */}
                <rect x="0" y="15" rx="5" ry="5" width="50" height="50" />

                {/* Title (Sparkasse) */}
                <rect x="70" y="15" rx="5" ry="5" width="150" height="15" />

                {/* Status (Closed) */}
                <rect x="70" y="50" rx="5" ry="5" width="100" height="15" />

                {/* Sub-text (test group) */}
                <rect x="70" y="75" rx="5" ry="5" width="250" height="15" />


                {/* Launch button */}
                <rect x="420" y="15" rx="5" ry="5" width="80" height="20" />
            </ContentLoader>

        </div>
    )
}

export default CommunityCardLoader